<div class="details-container" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
    <app-header class="the-header"></app-header>
    <div class="news-container container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-7 col-12 details py-5">
            <div class="blog-header">
              <div class="social-container">
                <a [href]="twitterLink" target="_blank" class="social-link"><i class="fa fa-twitter"></i></a>
                <a [href]="facebookLink" target="_blank" class="social-link"><i class="fa fa-facebook"></i></a>
              </div>
              <div class="text-center blog-title">
                <p class="title"> {{title}} </p>
                <p class="date"> {{date}} </p>
              </div>
            </div>
            <hr>
            <img [src]="image_url">
            <p class="summary">{{summary}}</p>
            <div class="body" [innerHTML]="body"></div>
          </div>
          <div class="col-lg-4 col-md-5 col-12 py-5 main-box">
            <div class="box-container">
                <p class="box-title">ROBOGARDEN</p>
                <p class="box-text">Do you want to learn coding in less time than possible and without any money, join
                    us on
                    the best platform ever on learning coding as a game for kids? </p>
            </div>
            <div class="coding-importance">
                <p>IMPORTANCE OF CODING EDUCATION </p>
                <ul>
                    <li><a (click)="goTo('hour-of-code')">Hour of code</a></li>
                    <li><a  (click)="goTo('facebook-has-now-become-more-secure')">Facebook has now become more secure</a></li>
                    <li><a (click)="goTo('apple-celebrates-10-year-birthday-of-the-app-store')">Apple celebrates 10-year birthday of the App Store</a></li>
                    <li><a (click)="goTo('gess-education-awards')">GESS Education Awards</a></li>
                </ul>
            </div>
        </div>

      </div>
    </div>
  </div>

  <app-subscribe></app-subscribe>
  <app-footer></app-footer>
</div>